// extracted by mini-css-extract-plugin
export default {"zoomModal":"n2-z"};